/**@jsxImportSource theme-ui */

import React from 'react';
import { Divider as ThemeUIDivider, ResponsiveStyleValue } from 'theme-ui';
import { AllCaroteneColors, PaddingProps, SpaceSizing, StyleOverrideProps } from '../utils/types';

export interface DividerProps extends PaddingProps, StyleOverrideProps {
    stack?: ResponsiveStyleValue<SpaceSizing>;
    color?: ResponsiveStyleValue<AllCaroteneColors>;
}
export function Divider({
    sx,
    stack,
    padding,
    paddingTopBottom,
    paddingLeftRight,
    color,
    ...otherProps
}: DividerProps): JSX.Element {
    return (
        <ThemeUIDivider
            sx={{
                ...sx,
                borderColor: color,
                margin: padding,
                marginLeft: paddingLeftRight,
                marginRight: paddingLeftRight,
                marginTop: paddingTopBottom,
                marginBottom: stack || paddingTopBottom,
            }}
            {...otherProps}
        />
    );
}

Divider.defaultProps = {
    padding: 'none',
};
